// src/globals/aliases.ts
import { adminAct } from "@/lib/edge/adminAct";

declare global { // чтобы TS не ругался
   
  var resolveAdminAct: ((act: string, payload?: unknown) => Promise<any>) | undefined;
}

if (typeof globalThis !== "undefined" && (globalThis as any).resolveAdminAct === undefined) {
  (globalThis as any).resolveAdminAct = adminAct;
}